import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=622c70a6&scoped=true&"
import script from "./sign-in.vue?vue&type=script&lang=js&"
export * from "./sign-in.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c70a6",
  null
  
)

export default component.exports